module.exports = __webpack_public_path__ + "static/media/RaisingChildren_web_2_preview.e7581e23.jpg";